import React from 'react';
import { useLocation, Navigate, Outlet } from 'react-router-dom';

import { isAuthenticatedSelector } from 'redux/selectors/authenticationSelectors';
import { useAppSelector } from 'hooks/useAppSelector';

// A wrapper for <Route> that redirects to the home page
// if user is authenticated and trying to access auth pages
export default function AuthRoute() {
  const isAuthenticated = useAppSelector(isAuthenticatedSelector);
  const location = useLocation();

  return isAuthenticated ? (
    <Navigate to="/" state={{ from: location }} />
  ) : (
    <Outlet />
  );
}
